import { Stepper } from "@features/stepper/Stepper";
import { useCallback, useEffect } from "react";
import { ICart } from "@features/cart/ICart";
import { ROUTES } from "@constants";
import { useGetCart } from "@hooks/useGetCart";
import { useHistory } from "react-router-dom";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { useGetCustomerDetails } from "@features/customerDetails/hook/useGetCustomerDetails";
import { sendViewCartEvent } from "@features/dataLayer/viewCart";

export const StepperPage = () => {
    const { push } = useHistory();

    const checkCart = useCallback(
        (cart: ICart | undefined) => {
            const hasCartOffers = cart?.offers?.length;

            if (!hasCartOffers) {
                push(ROUTES.BASE_URL);
            }
        },
        [push]
    );

    const { initialCart, cart, cartState, setCart, getCart } = useGetCart(checkCart);
    const {
        customerDetails,
        setCustomerDetails,
        getCustomerDetailsState,
        getCustomerDetails,
    } = useGetCustomerDetails();

    useEffect(() => {
        if (initialCart) {
            sendViewCartEvent(initialCart);
        }
    }, [initialCart]);

    return (
        <HandleErrorAndLoading error={cartState.error} isLoading={cartState.isLoading} retryFetch={getCart}>
            {cart && (
                <Stepper
                    cart={cart}
                    customerDetails={customerDetails}
                    getCustomerDetails={getCustomerDetails}
                    getCustomerDetailsState={getCustomerDetailsState}
                    setCart={setCart}
                    setCustomerDetails={setCustomerDetails}
                />
            )}
        </HandleErrorAndLoading>
    );
};
